import Reveal from './Reveal';

const PATH = 'M58 118 C 150 30, 250 26, 338 58';

export const TradeRoute = () => (
  <Reveal>
    <div
      data-testid="trade-route-visual"
      className="rounded-3xl border border-line bg-white p-6 shadow-card sm:p-8"
    >
      <div className="mb-2 flex items-center justify-between">
        <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-gold">Trade Pathways</p>
        <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-ink/40">Future-Oriented</p>
      </div>
      <svg viewBox="0 0 400 150" className="w-full" role="img" aria-label="Animated trade route from India to the UAE and international markets">
        <defs>
          <linearGradient id="routeGrad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#234D36" />
            <stop offset="100%" stopColor="#C89B3C" />
          </linearGradient>
        </defs>
        <path d={PATH} fill="none" stroke="#E2DAC8" strokeWidth="2" strokeDasharray="3 9" />
        <path
          d={PATH}
          fill="none"
          stroke="url(#routeGrad)"
          strokeWidth="2"
          strokeDasharray="4 8"
          className="animate-dash-flow"
          strokeLinecap="round"
        />
        <circle r="5" fill="#C89B3C">
          <animateMotion dur="6s" repeatCount="indefinite" path={PATH} />
        </circle>
        <g>
          <circle cx="58" cy="118" r="7" fill="#234D36" />
          <circle cx="58" cy="118" r="7" fill="#234D36" opacity="0.3" className="animate-pulse-ring" style={{ transformOrigin: '58px 118px' }} />
          <text x="58" y="140" textAnchor="middle" fontSize="11" fontWeight="700" fill="#234D36">INDIA · PUNE</text>
        </g>
        <g>
          <circle cx="196" cy="52" r="4" fill="#A8C3A0" />
          <text x="196" y="38" textAnchor="middle" fontSize="10" fontWeight="600" fill="#4A584E">UAE · DUBAI</text>
        </g>
        <g>
          <circle cx="338" cy="58" r="7" fill="#C89B3C" />
          <circle cx="338" cy="58" r="7" fill="#C89B3C" opacity="0.3" className="animate-pulse-ring" style={{ transformOrigin: '338px 58px' }} />
          <text x="338" y="80" textAnchor="middle" fontSize="11" fontWeight="700" fill="#1F2A22">INTERNATIONAL</text>
        </g>
      </svg>
      <p className="mt-3 text-center text-xs leading-relaxed text-muted-foreground">
        Building pathways from India to international markets — with an initial focus on the UAE.
      </p>
    </div>
  </Reveal>
);

export default TradeRoute;
